import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstance1zv30reud8vnz as Data_getInstance } from './adapter/SavePlayerMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SavePlayerMutation_VariablesAdapter_instance3ezv956cbflo8 as SavePlayerMutation_VariablesAdapter_instance } from './adapter/SavePlayerMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(savePlayer) {
        this.i6h_1 = savePlayer;
      }
      toString() {
        return 'Data(savePlayer=' + this.i6h_1 + ')';
      }
      hashCode() {
        return this.i6h_1 == null ? 0 : getBooleanHashCode(this.i6h_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.i6h_1 == other.i6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.j6h_1 = '5455c8cf2a3b7e1b46acf575b30dd18c607505908c6096cab88915de6fab9630';
        this.k6h_1 = 'savePlayer';
      }
      a6f() {
        return 'mutation savePlayer($input: SavePlayerInput!) { savePlayer(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var SavePlayerMutationClass;
function SavePlayerMutation() {
  if (SavePlayerMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.l6h_1 = input;
      }
      c6f() {
        return '5455c8cf2a3b7e1b46acf575b30dd18c607505908c6096cab88915de6fab9630';
      }
      operationId() {
        return this.c6f();
      }
      u47() {
        return Companion_instance.a6f();
      }
      d6f() {
        return 'savePlayer';
      }
      operationName() {
        return this.d6f();
      }
      o46(writer, customScalarAdapters, withDefaultValues) {
        SavePlayerMutation_VariablesAdapter_instance.m6h(writer, this, customScalarAdapters, withDefaultValues);
      }
      n46() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'SavePlayerMutation(input=' + this.l6h_1.toString() + ')';
      }
      hashCode() {
        return this.l6h_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerMutation()))
          return false;
        if (!this.l6h_1.equals(other.l6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerMutation', VOID, VOID, [Mutation()]);
    SavePlayerMutationClass = $;
  }
  return SavePlayerMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data1i1ryxd63q3t,
  SavePlayerMutation as SavePlayerMutation13ci6nh8jmmgu,
};
//endregion

//# sourceMappingURL=SavePlayerMutation.mjs.map
